import { Serializable } from '@admin/core/models/serializable';
import { AnnouncementMatchingListApprovalStatus } from './announcement-matching-list-approval-status.enum';

export class AnnouncementMatchingModel
  implements Serializable<AnnouncementMatchingModel>
{
  fromObject(object: any): AnnouncementMatchingModel {
    Object.assign(this, object);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public announcementMatchingListId: number;
  public portfolioId: number;
  public portfolio: string;
  public publishDate: Date;
  public announcementTitle: string;
  public companyName: string;
  public status: number;
  public matches: number;
  public accepted: number;
  public rejected: number;
  public ambiguous: number;
  public isHighlight: boolean;
}
